import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Blogs from "./pages/Blogs";
import PressReleases from "./pages/PressReleases";
import GtfSpotlight from "./pages/GtfSpotlight";
import SimplySmart from "./pages/SimplySmart";
import GloballySmart from "./pages/GloballySmart";
import News from "./pages/News";
import UniversityRequests from "./pages/UniversityRequests";
import StudentRequests from "./pages/StudentRequests";
import UniversitiesList from "./pages/UniversitiesList";
import StudentsList from "./pages/StudentsList";
import Mentors from "./pages/Mentors";
import Advisors from "./pages/Advisors";
import Experts from "./pages/Experts";
import TeamMembers from "./pages/TeamMembers";
import Popups from "./pages/Popups";
import LatestUpdates from "./pages/LatestUpdates";
import LoginPage from "./pages/LoginPage";
import FeedbackPage from "./pages/FeedbackPage";
import Events from "./pages/Events";
import ContactPage from "./pages/ContactPage";
import Careers from "./pages/Careers";
import Partnerships from "./pages/Partnerships";
import ResourceDownloads from "./pages/ResourceDownloads";
import "./App.css";

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function AppContent() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { admin } = useAuth();

  return (
    <Router>
      {admin ? (
        <DashboardLayout 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen}
        >
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs"
              element={
                <ProtectedRoute>
                  <Blogs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/press-releases"
              element={
                <ProtectedRoute>
                  <PressReleases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gtf-spotlight"
              element={
                <ProtectedRoute>
                  <GtfSpotlight />
                </ProtectedRoute>
              }
            />
            <Route
              path="/simply-smart"
              element={
                <ProtectedRoute>
                  <SimplySmart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/globally-smart"
              element={
                <ProtectedRoute>
                  <GloballySmart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/university-requests"
              element={
                <ProtectedRoute>
                  <UniversityRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/student-requests"
              element={
                <ProtectedRoute>
                  <StudentRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/universities-list"
              element={
                <ProtectedRoute>
                  <UniversitiesList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/students-list"
              element={
                <ProtectedRoute>
                  <StudentsList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/news"
              element={
                <ProtectedRoute>
                  <News />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mentors"
              element={
                <ProtectedRoute>
                  <Mentors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/advisors"
              element={
                <ProtectedRoute>
                  <Advisors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/experts"
              element={
                <ProtectedRoute>
                  <Experts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team-members"
              element={
                <ProtectedRoute>
                  <TeamMembers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/popups"
              element={
                <ProtectedRoute>
                  <Popups />
                </ProtectedRoute>
              }
            />
            <Route
              path="/latest-updates"
              element={
                <ProtectedRoute>
                  <LatestUpdates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <FeedbackPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/careers"
              element={
                <ProtectedRoute>
                  <Careers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contact"
              element={
                <ProtectedRoute>
                  <ContactPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/partnerships"
              element={
                <ProtectedRoute>
                  <Partnerships />
                </ProtectedRoute>
              }
            />
            <Route
              path="/careers"
              element={
                <ProtectedRoute>
                  <Careers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/resource-downloads"
              element={
                <ProtectedRoute>
                  <ResourceDownloads />
                </ProtectedRoute>
              }
            />
            {/* Catch-all route for authenticated users */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </DashboardLayout>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;